<template>
	<v-dialog v-model="showDialog" max-width="600" persistent>
		<v-card>
			<v-card-title> Add Activity Item</v-card-title>
			<v-card-text>
				<v-form ref="form">
					<v-row no-gutters>
						<v-col>
							<v-menu
								v-model="startDateMenu"
								:close-on-content-click="false"
								:nudge-right="40"
								transition="scale-transition"
								offset-y
								min-width="auto"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
										:value="
											getDateTimeFormat(
												activityItem.StartDate
											)
										"
										label="Start Date"
										prepend-icon="mdi-calendar"
										readonly
										v-bind="attrs"
										v-on="on"
										:rules="[
											(value) =>
												!!value ||
												'Start Date is required',
										]"
									></v-text-field>
								</template>
								<v-date-picker
									v-model="activityItem.StartDate"
									@input="startDateMenu = false"
									no-title
									color="green"
								></v-date-picker>
							</v-menu>
						</v-col>
						<v-col>
							<v-menu
								v-model="endDateMenu"
								:close-on-content-click="false"
								:nudge-right="40"
								transition="scale-transition"
								offset-y
								min-width="auto"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
										:value="
											getDateTimeFormat(
												activityItem.EndDate
											)
										"
										label="End Date"
										prepend-icon="mdi-calendar"
										readonly
										v-bind="attrs"
										v-on="on"
										:rules="[
											(value) =>
												!!value ||
												'End Date is required',
										]"
									></v-text-field>
								</template>
								<v-date-picker
									v-model="activityItem.EndDate"
									@input="endDateMenu = false"
									no-title
									color="green"
								></v-date-picker>
							</v-menu>
						</v-col>
					</v-row>
					<v-row
						no-gutters
						v-for="(item, index) in staticFields"
						:key="index"
					>
						<v-col>
							<activity-item-static-field
								:field="item"
								:index="index"
								:activityItem="activityItem"
								@change="onActivityItemStaticFieldChanged"
							/>
						</v-col>
					</v-row>

					<v-row
						no-gutters
						v-for="item in groupByList"
						:key="item.Id"
					>
						<v-col>
							<ActivityItemGroupByCriteria
								:item="item"
								:listId="item.Id"
								:activityItem="activityItem"
								@change="onActivityItemGroupByCriteriaChanged"
							/>
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>
			<v-divider />
			<v-card-actions>
				<v-btn @click.stop="onClose">Close</v-btn>
				<v-spacer />
				<v-btn color="primary" @click.stop="onSave">Save</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import { ActivityItemModalActions } from '../../../../../store/actions';
import { ActivityItemModalGetters } from '../../../../../store/getters';
import { mapGetters } from 'vuex';
import gridViewFieldUtils from '../../../../../utils/gridViewFieldsUtils';
import ActivityItemStaticField from '../activityItemModalComponents/ActivityItemStaticField.vue';
import projectSettingsMixin from '../../../../../mixins/projectSettingsMixin';
import ActivityItemGroupByCriteria from '../activityItemModalComponents/ActivityItemGroupByCriteria.vue';
export default {
	name: 'ActivityItemModal',
	data() {
		return {
			startDateMenu: false,
			endDateMenu: false,
			test: null,
			groupByCriteria: [],
			loaded: false,
			selectedFiltersValues: [],
			selected: {},
		};
	},
	mixins: [projectSettingsMixin],
	components: { ActivityItemStaticField, ActivityItemGroupByCriteria },
	computed: {
		...mapGetters({
			staticFields: [ActivityItemModalGetters.STATIC_FIELDS],
			groupByList: [ActivityItemModalGetters.GROUP_BY_LIST],
			gridViewFieldIds: [ActivityItemModalGetters.GRID_VIEW_FIELDS_IDS],
			activityItemGroupByFieldsValues: [
				ActivityItemModalGetters.ACTIVITY_ITEM_GROUP_BY_FIELDS_VALUES,
			],
		}),
		selectedFilters() {
			let result = [];
			this.selectedFiltersValues.forEach((x) => {
				if (x.Value != null) {
					let obj = {};
					obj[x.GridViewFieldId] = x.Value;
					result.push(obj);
				}
			});
			return result;
		},
	},
	props: {
		showDialog: Boolean,
		activityItem: Object,
	},
	methods: {
		onClose() {
			this.$emit('close');
		},
		onSave() {
			this.activityItem.GroupByCriteria = this.groupByCriteria;
			if (this.$refs.form.validate()) {
				if (!this.activityItem.Id) {
					this.$store
						.dispatch(
							ActivityItemModalActions.INSERT,
							this.activityItem
						)
						.then(() => this.$emit('close'));
				} else {
					this.$store
						.dispatch(
							ActivityItemModalActions.UPDATE,
							this.activityItem
						)
						.then(() => this.$emit('close'));
				}
				this.$emit('close');
			}
		},
		onActivityItemStaticFieldChanged(param, index) {
			if (this.activityItem.StaticFields[index])
				this.activityItem.StaticFields[index] = param;
			else this.activityItem.StaticFields.push(param);
		},
		onActivityItemGroupByCriteriaChanged(param, listId) {
			let selectedGridViewFields = this.groupByList.find(
				(x) => x.Id == listId
			).GridViewFields;
			selectedGridViewFields.forEach((gvf) => {
				let filterValueIndex = this.selectedFiltersValues.findIndex(
					(f) => f.GridViewFieldId == gvf.Id
				);
				if (filterValueIndex > -1)
					if (param) {
						let paramValue =
							param[gridViewFieldUtils.getFieldName(gvf)];
						if (paramValue === 'null') paramValue = null;
						this.selectedFiltersValues[filterValueIndex].Value =
							paramValue;
					} else {
						this.selectedFiltersValues[filterValueIndex].Value = '';
					}
			});

			this.$store.dispatch(
				ActivityItemModalActions.LOAD_GROUP_BY_CRITERIA_VALUES,
				{
					activityId: this.activityItem.ActivityId,
					filters: this.selectedFilters,
				}
			);
		},
	},
	destroyed() {
		this.$store.dispatch(ActivityItemModalActions.CLEAR);
	},
	mounted() {
		this.activityItem.ActivityId = this.$route.params.id;
		this.$store
			.dispatch(ActivityItemModalActions.LOAD, {
				itemId: this.activityItem.Id,
				activityId: this.activityItem.ActivityId,
			})
			.then(() => {
				this.gridViewFieldIds.forEach((gvfId) => {
					this.selectedFiltersValues.push({
						GridViewFieldId: gvfId,
						Value: null,
					});
				});
				this.activityItemGroupByFieldsValues.forEach((x) => {
					let item = this.selectedFiltersValues.find(
						(y) =>
							y.GridViewFieldId ==
							x.ActivityGroupByConditionFieldGridViewFieldId
					);
					if (item) {
						let val = x.Value;
						if (val === 'null') val = null;
						item.Value = val;
					}
				});
				this.$store.dispatch(
					ActivityItemModalActions.LOAD_GROUP_BY_CRITERIA_VALUES,
					{
						activityId: this.activityItem.ActivityId,
						filters: this.selectedFilters,
					}
				);
			});
	},
};
</script>
